/**
 * Stable CSS class names for E2E / automation on Store Cargo Blocking.
 * Combine layout sections with `store-cargo-blocking-input--{kind}` on interactive controls.
 */
export const SCB = {
    page: 'store-cargo-blocking-page',
    paper: 'store-cargo-blocking-page__paper',
    toolbar: 'store-cargo-blocking-page__toolbar',
    bulkActions: 'store-cargo-blocking-page__bulk-actions',
    datagrid: 'store-cargo-blocking-page__datagrid',
    emptyState: 'store-cargo-blocking-page__empty-state',

    drawer: 'store-cargo-blocking-drawer',
    drawerSearch: 'store-cargo-blocking-drawer--search',
    drawerAdd: 'store-cargo-blocking-drawer--add',
    drawerBody: 'store-cargo-blocking-drawer__body',
    drawerForm: 'store-cargo-blocking-drawer__form',
    drawerActions: 'store-cargo-blocking-drawer__actions',

    input: 'store-cargo-blocking-input',
    inputButton: 'store-cargo-blocking-input--button',
    inputCheckbox: 'store-cargo-blocking-input--checkbox',
    inputAutocomplete: 'store-cargo-blocking-input--autocomplete',
    inputTextfield: 'store-cargo-blocking-input--textfield',
    fieldCargoCompany: 'store-cargo-blocking-field--cargo-company',
    fieldStoreName: 'store-cargo-blocking-field--store-name',

    btnAddNew: 'store-cargo-blocking-field--add-new',
    btnExportExcel: 'store-cargo-blocking-field--export-excel',
    btnOpenSearch: 'store-cargo-blocking-field--open-search',
    btnBulkDelete: 'store-cargo-blocking-field--bulk-delete',
    btnDeleteRow: 'store-cargo-blocking-field--delete-row',
    btnEmptySearch: 'store-cargo-blocking-field--empty-search',

    btnDrawerClear: 'store-cargo-blocking-field--drawer-clear',
    btnDrawerSubmit: 'store-cargo-blocking-field--drawer-submit',

    cbStoreOption: 'store-cargo-blocking-field--store-option-checkbox',
    cbGridSelection: 'store-cargo-blocking-field--grid-selection-checkbox',
} as const;

export const scbCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
